<template>
  <div class="col-md-2 menu pb-4" v-if="this.user != null">
    <div class="">
      <div class="col-12 bggris white py-2">
        <div class="text-left ">Menú</div>
      </div>
    </div>

    <div class="">
      <div class="col-12 bgblanco pb-4 nopadding">
        <ul>
          <li>
            <router-link to="/dashboard">
              <i class="fas fa-clipboard-list"></i>
              <span class="pl-2 bold">Registros</span>
            </router-link>
          </li>
          <li v-if="this.$store.state.user.user_level == 1">
            <router-link to="/registro">
              <i class="fas fa-plus-circle"></i>
              <span class="pl-2 bold">Crear registro</span>
            </router-link>
          </li>
          <!-- <li>
            <router-link to="/proceso-endoso">
              <i class="far fa-file"></i>
              <span class="pl-2">Proceso de endoso</span>
            </router-link>
          </li> -->
          <li>
            <router-link to="/reportes/generar-reporte">
              <i class="fas fa-file-alt"></i>
              <span class="pl-2 bold">Generar reporte</span>
            </router-link>
          </li>
          <li>
            <router-link to="/usuarios" v-if="this.$store.state.user.id == 1 || this.$store.state.user.id == 38">
              <i class="fas fa-users"></i>
              <span class="pl-2 bold">Usuarios</span>
            </router-link>
          </li>
          <li>
            <router-link to="/administradores" v-if="this.$store.state.user.id == 1 || this.$store.state.user.id == 38">
              <i class="fas fa-file"></i>
              <span class="pl-2 bold">Administración</span>
            </router-link>
          </li>
          <!-- <li v-if="this.$store.state.user.user_level == 1">
            <router-link to="/configuracion">
              <i class="fas fa-cog"></i>
              <span class="pl-2 bold">Configuración</span>
            </router-link>
          </li> -->
          <!-- <li>
            <router-link to="/ayuda">
              <i class="fas fa-question-circle"></i>
              <span class="pl-2">Ayuda</span>
            </router-link>
          </li> -->
          
         
        </ul>
      </div>
    </div>

    <!-- <div class="row" v-if="this.user.user_level == 2">
      <div class="col-12 bgblanco rounded pt-3 pb-2">
        <ul>
          <li>
            <router-link to="/egresados/estatus">
              <i class="fas fa-users"></i>
              <span class="pl-2">Estado de Titulación</span>
            </router-link>
          </li>
          
        </ul>
      </div>

      
    </div> -->

    <!-- <div class="row" v-if="this.user.user_level == 5">
      <div class="col-12 bgblanco rounded pt-3 pb-4">
        <ul>
          <li>
            <router-link to="/docentes/asignaturas">
              <i class="fas fa-pencil-alt"></i>
              <span class="pl-2">Asignaturas</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div> -->

    <!-- <div class="row" v-if="this.user.user_level == 7">
      <div class="col-12 bgblanco rounded pt-3 pb-4">
        <ul>
          <li>
            <router-link to="/dashboard/alumnos">
              <i class="fas fa-user-friends"></i>
              <span class="pl-2">Alumnos</span>
            </router-link>
          </li>
         
        </ul>
      </div>
    </div> -->

    

    <div class=" pt-5 btns">
      <!-- <div class="col-6 pb-2">
        <a href="http://app.vlex.com/#account/login" target="_blank">
          <img
            class="img-fluid w-75 pt-2 float-right"
            src="../assets/imgs/logo-vlex-azul.png"
            alt="Vlex App"
            title="Ir a Vlex App"
          />
        </a>
      </div>
      <div class="col-6 text-center">
        <a href="https://mail.google.com/" target="_blank">
          <img
            class="img-fluid w-50 pt-2 float-left"
            src="../assets/imgs/gmail-logo.png"
            alt="Gmail"
            title="Ir a Gmail"
          />
        </a>
      </div> -->
      <div class="col-12 text-center gris w-100">© 2021 GAIG. {{version}} </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Menu",

  props: {
    msg: String
  },
  data() {
    return {
      version: "",
      user: null,
      inicio_periodo_escolar: "",
      fin_periodo_escolar: ""
    };
  },
  mounted: function() {
    this.$store.state.user = JSON.parse(this.$cookie.get("usergaig"));
    this.user = this.$store.state.user;
    this.version = this.$store.state.version;
    this.user = {};

  },
  methods: {
    
  }
};
</script>

